import * as React from "react";
import {Image, tokens, makeStyles, Button} from "@fluentui/react-components";

const useStyles = makeStyles({
    welcome__header: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "15px",
        paddingBottom: "15px",
        paddingTop: "15px",
        paddingLeft: "20px",
        backgroundColor: tokens.colorNeutralBackground3,
    },
    textContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    title: {
        fontSize: tokens.fontSizeBase300,
        fontWeight: tokens.fontWeightMedium,
        margin: 0,
        lineHeight: "1.5",
    },
    version: {
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralForeground2,
        margin: 0,
        lineHeight: "1.5",
    },
});

const Header: React.FC = () => {
    const styles = useStyles();

    return (
        <section className={styles.welcome__header}>
            <Image width="30" height="30" src="assets/icon-80.png"/>

            <div className={styles.textContainer}>
                <h3 className={styles.title}>Classement de mails dans zLawyer</h3>
                <p className={styles.version}>v2026.10.11.1</p>
            </div>
        </section>
    );
};

export default Header;
